import { useState, useEffect, useCallback } from 'react'
import { isFormValid } from '../../functions'
import { DeleteFormValidationHook } from '../types/validationTypes'

export const useDeleteFormValidation = (): DeleteFormValidationHook => {
  const [deleteReason, setDeleteReason] = useState('')
  const [deleteComment, setDeleteComment] = useState('')
  const [disabled, setIsDisabled] = useState(true)
  const [validationErrors, setValidationErrors] = useState<any>({})

  useEffect(() => {
    if (deleteReason && deleteComment) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [deleteReason, deleteComment])

  const validateForm = useCallback(
    () => isFormValid(setValidationErrors, deleteReason, deleteComment),
    [deleteReason, deleteComment]
  )

  const resetForm = useCallback(() => {
    setDeleteReason('')
    setDeleteComment('')
    setIsDisabled(true)
    setValidationErrors({})
  }, [])

  return {
    deleteReason,
    deleteComment,
    disabled,
    validationErrors,

    setDeleteReason,
    setDeleteComment,
    validateForm,
    resetForm,
  }
}
